<template>
  <div class="gallery">
    <div class="thumbs">
      <div
        v-for="(image, index) in images"
        v-bind:key="index"
        :data-index="index"
        class="image"
        :style="`background-image: url(${image.image_thumbnail.url}); height: ${image.image_thumbnail.height}px`"
        :title="image.image.title"
        @click="handleThumbClick"
      >
        <div class="description" v-if="image.description" v-html="image.description"></div>
      </div>
    </div>

    <div v-if="currentImage >= 0" class="full-view" :data-show-controls="showControls">
      <img @click.prevent="handleImageClick" :src="images[currentImage].image.meta.download_url" />

      <div class="image-footer">
        <h3>{{ images[currentImage].image.title }}</h3>

        <div class="description" v-if="images[currentImage].description" v-html="images[currentImage].description"></div>

      </div>

      <button @click.prevent="handleCloseClick" class="button button-close"><CrossSVG /></button>
      <button @click.prevent="handlePreviousClick" class="button button-nav button-previous"><PlaySVG /></button>
      <button @click.prevent="handleNextClick" class="button button-nav button-next"><PlaySVG /></button>
    </div>
  </div>
</template>

<script>
import CrossSVG from "@/assets/cross.svg"
import PlaySVG from "@/assets/play3.svg"

export default {
  name: "Gallery",
  components: {
    CrossSVG,
    PlaySVG,
  },
  props: {
    images: Array,
  },
  data: () => {
    return {
      currentImage: -1,
      showControls: true,
    }
  },
  methods: {
    handleThumbClick (e) {
      this.showControls = true
      this.currentImage = e.target.dataset.index
    },
    handleNextClick () {
      const nextIndex = this.currentImage + 1
      if (nextIndex > this.images.length - 1) {
        this.currentImage = 0
      } else {
        this.currentImage = nextIndex
      }
    },
    handlePreviousClick () {
      const nextIndex = this.currentImage - 1
      if (nextIndex < 0) {
        this.currentImage = this.images.length - 1
      } else {
        this.currentImage = nextIndex
      }
    },
    handleCloseClick () {
      this.currentImage = -1
    },
    handleImageClick () {
      this.showControls = !this.showControls
    }
  }
}
</script>

<style lang="scss">
  .gallery {

    .thumbs {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: flex-start;

      .image {
        position: relative;
        width: calc(50% - 0.25em);
        max-height: 250px;
        margin-bottom: 0.5em;
        overflow: hidden;
        background-position: center;
        background-size: cover;
        cursor: pointer;

        @media screen and (max-width: $break-mobile) {
          width: 100%;
          max-height: calc(100vw / 2);
        }

        &:first-child {
          width: 100%;
          height: auto;
          max-height: 500px;
          min-height: 200px;
          @media screen and (max-width: $break-mobile) {
            min-height: none;
            max-height: calc(100vw / 2);
          }
        }

        .description {
          position: absolute;
          bottom: 0;
          right: 0;
          padding: 0.5em 1em;
          font-size: 14px;
          background: fade-out($color: $color-white, $amount: 0.2);

          p {
            font-size: 1em;
            line-height: 1.4;
            padding: 0;
            margin: 0;
          }
        }
      }
    }

    .full-view {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      z-index: 800;
      background: $color-black;

      &[data-show-controls="true"] {
        .image-footer {
          bottom: 0;
        }

        .button-nav {
          opacity: 1;
        }
      }

      .image-footer {
        position: fixed;
        bottom: -100%;
        left: 0;
        right: 0;
        text-align: center;
        background-color: $color-white;
        background-color: fade-out($color: $color-white, $amount: 0.5s);
        transition: bottom 0.2s ease-in-out;

        h3 {
          font-size: 16px;
          font-weight: normal;
        }

        .description {
          font-size: 14px;
          p {
            font-size: 1em;

          }
        }
      }

      img {
        display: block;
        width: auto;
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
      }

      .button {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        padding: 10px;
        border-radius: 50%;
        line-height: 1;
        background: $color-white;
        background-color: fade-out($color: $color-white, $amount: 0.5);
        border: none;
        text-align: center;
        cursor: pointer;
        transition: background-color 0.1s ease-in-out;

        svg {
          width: 15px;
          height: 15px;
        }

        &:hover {
          background-color: $color-white;
        }
      }

      .button-close {
        position: fixed;
        top: 20px;
        right: 20px;
      }

      .button-nav {
        position: fixed;
        top: 50%;
        padding-left: 15px;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
      }
      .button-previous {
        left: 20px;
        transform: rotate(180deg);
      }
      .button-next {
        right: 20px;
      }

    }
  }
</style>
